import React, { memo } from 'react';
import { translate } from '../../common/translation/translate';
import styled from 'styled-components';
import { defaultReading } from '../forecasts/common/utils';

interface DailyForecastSummaryBodyHeaderProps {
    temperature: string;
    units: string;
    forecastIndex: number;
    isNightTimePeriod: boolean;
}

export const DailyForecastSummaryBodyHeader = memo(({ 
    units,
    isNightTimePeriod,
    forecastIndex,
    temperature = defaultReading }: DailyForecastSummaryBodyHeaderProps) => {

    const todayOrTomorrowText = `${forecastIndex === 0 ? translate('today') : translate('tomorrow')}`;
    const displayDayText = `${ isNightTimePeriod ? translate('tonight') : todayOrTomorrowText}`;

    const isTomorrowLabel = forecastIndex !== 0 && isNightTimePeriod !== true;

    const temperatureReadingText = `${temperature}${units}`;
    const highLowTempStr = isNightTimePeriod ? 'Lo ' : 'Hi ';

    return (
        <Container>
            <HeaderTitle>
                <DayLabel>{displayDayText}</DayLabel>
                <ForecastPeriodTemperatureLabel isTomorrowLabel={isTomorrowLabel}>
                    {highLowTempStr}
                    <TemperatureReading>{temperatureReadingText}</TemperatureReading>
                </ForecastPeriodTemperatureLabel>
            </HeaderTitle>
        </Container>
    );
});

DailyForecastSummaryBodyHeader.displayName = 'DailyForecastSummaryBodyHeader';

const Container = styled.div`
    position: relative;
    padding: 8px 8px 10px 10px;
    height: 35px;
`;

const HeaderTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`;

const DayLabel = styled.span`
    width: 70px;
    font-size:16px;
    font-weight: 600;
    color:#666;
`;

interface ForecastPeriodTemperatureLabelProps {
    isTomorrowLabel: boolean;
}
const ForecastPeriodTemperatureLabel = styled.span<ForecastPeriodTemperatureLabelProps>`
    font-size:14px;
    font-weight: 400;
    color: #aaa;
    ${({ isTomorrowLabel }) => isTomorrowLabel && `
        margin-left: 5px;
    `}
`;

const TemperatureReading = styled.strong`
    color: #666;
`;
